// removed by extract-text-webpack-plugin
module.exports = {"container":"_1gSZQu2agc2UbWAcbdCQWs","rolesContainer":"n_VXBqmL5aNd6q7T-TYGY","grantsContainer":"WVpDq6tVBgStuie70xIG1","editModeContainer":"-V3_MzVLLW3YHTz3Nvspp","editBtn":"_4uzXEcyRDGmvgb-O7gabG","successBtn":"_2aGr676__6yMoBuO1jtji9","block":"_6ACRhwT41KK1YzdHpqWJJ","blockLabel":"_28GxsGn2GkDepwLlWfEHNY","radioContainer":"_6MdqVyTPEDXVktljRD4jG","lockedContainer":"_1Aq63LavqNRdD49muUvsh8","lockedIcon":"_3w-lBB0XuJuVHcjkjCGMYR","hint":"_2s64j2xtT4u3A63jJ6Vh7D"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Roles/style/Roles.pcss
// module id = 480
// module chunks = 0